<ion-content id="{{promotionContentId}}" *transloco="let t">
  <div class="safearea-wrapper">
  <ion-grid>
    <ion-row>
      <ion-col size="12" class="ion-text-right"
        ><ion-icon name="close" (click)="onClose()"></ion-icon
      ></ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="10" class="content ion-text-center">
        <ion-row><h5>{{title}}</h5></ion-row>
        <ion-row><span>{{subtitle}}</span></ion-row>
        <ion-row class="divider"></ion-row>
        <ion-row
          ><h5><strong>{{name}}</strong></h5></ion-row
        >
        <ion-row *ngIf="description"
          ><h6>
            {{description}}
          </h6></ion-row
        >
        <div class="qrcodeImage">
          <qrcode
            [qrdata]="code"
            [allowEmptyString]="true"
            [elementType]="'canvas'"
            [errorCorrectionLevel]="'Q'"
            [imageHeight]="75"
            [imageWidth]="75"
            [margin]="4"
            [scale]="1"
            [width]="300"
          ></qrcode>
        </div>
        <ion-row
          ><h6 style="font-size: 12px;">
            {{getDescription(timeRange)}}
          </h6></ion-row
        >
        <ion-row class="divider"></ion-row>
        <ion-row
          ><h6>
            {{getBottomCaption()}}
          </h6></ion-row
        >
        <ion-row *ngIf="type === PROMOTION_TYPES.DRINK"
          ><h6>{{t('promotion.drinkReminderMessage')}}</h6>
        </ion-row>
        <ion-row
          *ngIf="[PROMOTION_TYPES.FREE_MENU, PROMOTION_TYPES.DISCOUNT].includes(type)"
          ><h6>{{t('promotion.expireReminderMessage')}}</h6>
        </ion-row>
        <ion-row *ngIf="sponsor" class="sponsor">
          <ion-col size="12"
            ><span style="margin-bottom: 0;">
              {{t('promotion.sponsorMessage', {sponsor: sponsor.name})}}
            </span></ion-col
          >
          <ion-col size="12">
            <ion-img
              class="logo"
              [src]="sponsor.logo.thumb || sponsor.logo.url"
            ></ion-img> </ion-col
          ><ion-col size="12" *ngIf="banner">
            <ion-img class="banner" [src]="banner"></ion-img> </ion-col
        ></ion-row>

        <ng-container *ngIf="phone">
          <ion-row
            ><span style="margin-bottom: 0; margin-top: 10px;">
              {{t('promotion.callShopMessage')}}
            </span></ion-row
          >
          <ion-row
            style="margin-top: 5px; display: flex; align-items: center;"
            (click)="handleCall()"
          >
            <ion-icon
              name="call"
              style="margin-right: 5px; margin-top: 3px; font-size: 12px;"
            ></ion-icon>
            <ion-text color="primary"
              ><ion-label>{{phone}}</ion-label></ion-text
            >
          </ion-row>
        </ng-container>
      </ion-col>
      <ion-button
        *ngIf="shared"
        fill="clear"
        (click)="handleSharedPromotion()"
        >{{t('promotion.status.shared')}}</ion-button
      >
    </ion-row>
  </ion-grid>
  </div>
</ion-content>
